import authLink from './authLink'
import clientTypeLink from './clientTypeLink'
import errorLink from './errorLink'
import createHttpLink from './httpLink'
import createDeduplicatedMutationLink from './deduplicatedLink'

const deduplicatedLinks = createDeduplicatedMutationLink()

export default [authLink, clientTypeLink, deduplicatedLinks, errorLink]
export { createHttpLink }
